import { type } from 'arktype';

export const meta = (description: string, examples?: unknown[]) => (examples ? { description, examples } : { description });
export const stringField = (description: string, examples?: string[]) => type('string').configure(meta(description, examples));
export const booleanField = (description: string) => type('boolean').configure(meta(description));
export const numberField = (description: string) => type('number').configure(meta(description));
